import { render, staticRenderFns } from "./CurrentStockTab.vue?vue&type=template&id=1a9c9750&"
import script from "./CurrentStockTab.vue?vue&type=script&lang=js&"
export * from "./CurrentStockTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports